import { styled, TextField } from '@mui/material';

const UnderlineColorTextField = styled(
  TextField,
  { shouldForwardProp: (prop) => !['underlineColor', 'disabledColor'].includes(prop) },
)(({ underlineColor, disabledColor }) => ({
  '& .MuiInput-root': {
    '&::before, &::after, &:hover:before': {
      borderBottomColor: `${underlineColor} !important`,
    },
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: disabledColor,
  },
}));

export default UnderlineColorTextField;
